import useMediaQuery from '@mui/material/useMediaQuery';
import { CREATOR_MAP_MOBILE_MQL } from '../../utils/navigation/creatorMapVisibility';

/**
 * True when Influencer Map / Creator Map entry points should be hidden
 * (viewport below MUI `md` / 900px).
 */
export default function useHideCreatorMapEntryPoints() {
  return useMediaQuery(CREATOR_MAP_MOBILE_MQL);
}

export { CREATOR_MAP_MOBILE_MQL };
